import { useContext, useState } from 'react'
import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import "../GrievOmbudsman/GrievOmbudsman.scss"
import { useEffect } from 'react';
import { Button } from 'primereact/button';
import { AppContext } from "../../../context/AppContext"
import axios from 'axios';
import { toast } from 'react-toastify';
import SuccessDialog from '../../../components/SuccessDialog.jsx'
import { InputText } from 'primereact/inputtext';

const GrievOmbudsman = () => {
    const { backendUrl, setUpdateOmbudsmanGrievance, updateOmbudsmanGrievance } = useContext(AppContext);
    const [compliantsRegisterd, setCompliantsRegistered] = useState(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [compliantsPending, setCompliantsPending] = useState(null);
    const [compliantsResolved, setComplaintsResolved] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const eMailpattern = /^\S+@\S+\.\S+$/
    const contactNumberPattern = /^\d{10}$/
    const yearPattern = /^\d{4}$/

    const [updateTrigger, setUpdateTrigger] = useState(false);
    const [ombudsmanComplaintsFormData, setOmbudsmanComplaintsFormData] = useState({
        name: "",
        department: "",
        year: "",
        contactNumber: "",
        email: "",
        grievance: ""
    });

    async function grievanceRedressalData() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllOmbudsmanGrievances`);
            const complaints = data.data;
            const totalRegistered = complaints.length;
            const pending = complaints.filter(complaint => !complaint.resolved).length;
            const resolved = complaints.filter(complaint => complaint.resolved).length;
            setCompliantsRegistered(totalRegistered);
            setCompliantsPending(pending);
            setComplaintsResolved(resolved);
        } catch (error) {
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
            }
        }
    }

    useEffect(() => {
        grievanceRedressalData();
    }, [updateTrigger, backendUrl]);

    const [errors, setErrors] = useState({})

    const complaintsData = [
        { number: compliantsRegisterd, para: "COMPLAINTS REGISTERED" },
        { number: compliantsPending, para: "COMPLAINTS PENDING" },
        { number: compliantsResolved, para: "COMPLAINTS RESOLVED" }
    ];

    const complaintsRegisterFields = [
        { fieldName: "name", placeholder: "Enter Your Name", label: "Name", type: "text", className: "ombudsman-form-input" },
        { fieldName: "department", placeholder: "Enter Department", label: "Department", type: "text", className: "ombudsman-form-input" },
        { fieldName: "year", placeholder: "Enter Year (YYYY)", label: "Year", type: "text", className: "ombudsman-form-input", keyFilter: "int", maxLength: 4 },
        { fieldName: "contactNumber", placeholder: "Enter 10 digit Contact Number", label: "Contact Number", type: "tel", className: "ombudsman-form-input", keyFilter: "int", maxLength: 10 },
        { fieldName: "email", placeholder: "Enter Email ID", label: "Email ID", type: "email", className: "ombudsman-form-input" },
        { fieldName: "grievance", placeholder: "Enter Your Grievances", label: "Your Grievances", type: "text", className: "ombudsman-form-input" },
    ];

    const firstColumn = complaintsRegisterFields.slice(0, 3);
    const secondColumn = complaintsRegisterFields.slice(3);
    const handleComplaintsFieldInputChange = (e) => {
        const { name, value } = e.target;
        setOmbudsmanComplaintsFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ""
        }));
    };

    const validateForm = () => {
        const testeMailpattern = eMailpattern.test(ombudsmanComplaintsFormData.email)
        const testcontactNumberPattern = contactNumberPattern.test(ombudsmanComplaintsFormData.contactNumber)
        const testYearPattern = yearPattern.test(ombudsmanComplaintsFormData.year)
        const error = {};
        if (!ombudsmanComplaintsFormData.name.trim()) {
            error.name = ["Required"]
        }
        if (!ombudsmanComplaintsFormData.contactNumber.trim()) {
            error.contactNumber = ["Required"]
        }
        else if (!testcontactNumberPattern) {
            error.contactNumber = ["Invalid Phone Number"]
        }
        else {

        }

        if (!ombudsmanComplaintsFormData.email.trim()) {
            error.email = ["Required"]
        }
        else if (!testeMailpattern) {
            error.email = ["Invalid Email"]
        }
        else {

        }

        if (!ombudsmanComplaintsFormData.department.trim()) {
            error.department = ["Required"]
        }

        if (!ombudsmanComplaintsFormData.year.trim()) {
            error.year = ["Required"]
        }
        else if (!testYearPattern) {
            error.year = "InValid Pattern"
        }
        else {

        }
        if (!ombudsmanComplaintsFormData.grievance.trim()) {
            error.grievance = ["Required"]
        }
        setErrors(error)
        return Object.keys(error).length === 0;
    }

    const clearForm = () => {
        setOmbudsmanComplaintsFormData({
            name: "",
            department: "",
            year: "",
            contactNumber: "",
            email: "",
            grievance: ""
        })
        setErrors({})
    }

    const complaintsFormSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            console.log('Form validation failed');
            return; 
        }

        setIsSubmitting(true);

        try {
            const res = await axios.post(`${backendUrl}/api/auth/submitOmbudsmanGrievance`, ombudsmanComplaintsFormData)
            if (res.data.success === true) {
                setShowSuccessDialog(true);
                clearForm();
                grievanceRedressalData();
                setUpdateOmbudsmanGrievance(!updateOmbudsmanGrievance);
            }
        }
        catch (error) {
            console.error('Error fetching users:', error);
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }
            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else if (error.response && error.response.status === 500) {
                toast.error("Internal Server Error")
                clearForm();
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Header />

            <SuccessDialog
                visible={showSuccessDialog}
                onHide={() => setShowSuccessDialog(false)}
                header="Complaint Registered"
                message="Your complaint has been registered successfully!"
                buttonLabel="OK"
            />

            <div className='campusmaincontainer'>
                <div className='campus-container'>
                    <div className='griev-ombuds-container'>
                        <div className='griev-ombuds-subcontainer'>
                            <h2 className='griev-ombuds-title'>Ombudsman</h2>
                            <div className='griev-complaint-container'>
                                {
                                    complaintsData.map((complaint, index) => <>
                                        <div className='griev-complaint-subcontainer'>
                                            <div className='griev-complaint'>
                                                <div className='griev-complaint-number'>{complaint.number}</div>
                                                <div className='griev-complaint-para'>{complaint.para}</div>
                                            </div>
                                        </div>
                                    </>)
                                }
                            </div>
                        </div>
                        <div className='ombudsman-form-main-container'>
                            <div className='ombudsman-form-subcontainer'>
                                <div className='ombudsman-form-title'><h2>Ombudsman</h2></div>
                                <form onSubmit={complaintsFormSubmit}>
                                    <div className='ombudsman-form-container'>
                                        <div className='ombudsman-form'>
                                            {firstColumn.map((field, index) => (
                                                <div key={index}>
                                                    <label htmlFor={field.fieldName}>{field.label}</label>
                                                    <InputText
                                                        type={field.type}
                                                        className={`${field.className} ${errors[field.fieldName] ? 'invalid' : ''}`}
                                                        id={field.fieldName}
                                                        placeholder={field.placeholder}
                                                        name={field.fieldName}
                                                        onChange={handleComplaintsFieldInputChange}
                                                        value={ombudsmanComplaintsFormData[field.fieldName]}
                                                        keyfilter={field.keyFilter}
                                                        maxLength={field.maxLength}
                                                    />
                                                    {errors[field.fieldName] && (
                                                        <p className="error-message">{errors[field.fieldName]}</p>
                                                    )}
                                                </div>
                                            ))
                                            }
                                        </div>

                                        <div className='ombudsman-form'>
                                            {secondColumn.map((field, index) => (
                                                <div key={index}>
                                                    <label htmlFor={field.fieldName}>{field.label}</label>
                                                    <InputText
                                                        type={field.type}
                                                        className={`${field.className} ${errors[field.fieldName] ? 'invalid' : ''}`}
                                                        id={field.fieldName}
                                                        placeholder={field.placeholder}
                                                        name={field.fieldName}
                                                        onChange={handleComplaintsFieldInputChange}
                                                        value={ombudsmanComplaintsFormData[field.fieldName]}
                                                        keyfilter={field.keyFilter}
                                                        maxLength={field.maxLength}
                                                    />
                                                    {errors[field.fieldName] && (
                                                        <p className="error-message">{errors[field.fieldName]}</p>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className='ombudsman-form-button'>
                                        <Button
                                            label={isSubmitting ? "Submitting..." : "Submit"}
                                            icon={isSubmitting ? "pi pi-spin pi-spinner" : null}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default GrievOmbudsman